import { useEffect } from "react";
import { BrowserRouter, useLocation, useRoutes } from "react-router-dom";

import { Toaster } from "@/components/_atoms/sonner";
import { useAuth } from "@/domain/_shared/auth/hooks/api/use-auth";
import { setFaroView } from "@/services/faro.service";

import { routes } from "./app-router-config";

function InnerRouter() {
  const { authenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    setFaroView(location.pathname);
  }, [location.pathname]);

  const routing = useRoutes(routes(authenticated));

  return routing;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <InnerRouter />
      <Toaster />
    </BrowserRouter>
  );
}
